// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"f004961e","68":"d4070663","110":"cf6c47c1","270":"1537fd8f","276":"7262dcc6","332":"2c85ce60","367":"2f2d20c5","453":"ace21015","473":"5245ab27","489":"784aa56a","490":"59d25592","608":"93179a8b","840":"1581feea","977":"8454fb7b"}[chunkId] + ".chunk.js";
};